import { customAlphabet } from 'nanoid';
const custom = '123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
export default function(size = 5) {
  return customAlphabet(custom, size)();
}
